import _ from 'underscore';

import {SchemaTag} from 'folder-items/FileConstants';
import {FieldType} from 'schemas/fields/SchemaFieldConstants';
import {TagUpdateObject, getTagUpdateParams} from 'schemas/tags/TagUtil';

import {AdapterField, InstrumentServiceDetails} from '../ConnectionConstants';

export function convertToSchemaTag(
  field: AdapterField,
  instrumentServiceDetails?: InstrumentServiceDetails,
  value?: string | null
): SchemaTag {
  return {
    name: field.displayName,
    tagSchemaField: {
      displayName: field.displayName,
      name: field.displayName,
      fieldType: FieldType.TEXT,
      isUneditable: field.isUneditable || false,
      isRequired: field.isRequired,
      isComputed: false,
      isConvertedFromLink: false,
      isIntegration: false,
      systemName: field.id,
    },
    value:
      value ||
      (instrumentServiceDetails?.fields.hasOwnProperty(field.id)
        ? instrumentServiceDetails.fields[field.id].value
        : field.defaultValue || ''),
  } as SchemaTag;
}

export function getConnectionTagsToSet(tags: Array<SchemaTag>): TagUpdateObject {
  const trimmedTags = Array.isArray(tags)
    ? tags.map((tag) => ({...tag, value: tag.value?.trim() ?? ''}))
    : tags;
  // @ts-expect-error see https://github.com/benchling/aurelia/pull/12149
  return _.chain(trimmedTags)
    .indexBy((tag) => tag.tagSchemaField.systemName)
    .mapObject(getTagUpdateParams)
    .value();
}
